
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h30v30H0z"}})])]),_c('g',{attrs:{"data-name":"Artboard – 2","clip-path":"url(#a)"}},[_c('path',{attrs:{"fill":"rgba(255,255,255,0)","d":"M0 0h30v30H0z"}}),_c('g',{attrs:{"data-name":"2075796_arrow_down_go_two_up_icon","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 32480","d":"M18.285 16.296l.916.916 5.641-5.64-5.64-5.642-.916.916 4.076 4.078H4.501v1.3h17.861z"}}),_c('path',{attrs:{"data-name":"Path 32480 - Outline","d":"M25.549 11.572l-6.347 6.347-1.624-1.623 3.577-3.576H4.001v-2.3h17.154l-3.577-3.574 1.624-1.623zm-6.347 4.933l4.933-4.933-4.933-4.935-.209.209 4.576 4.578H5.001v.3h18.568L18.993 16.3z"}}),_c('path',{attrs:{"data-name":"Path 32481","d":"M11.427 24.071l-4.078-4.076h17.862v-1.3H7.349l4.078-4.074-.916-.916-5.642 5.642 5.642 5.64z"}}),_c('path',{attrs:{"data-name":"Path 32481 - Outline","d":"M4.162 19.347l6.349-6.349 1.623 1.623-3.578 3.578h17.155v2.3H8.556l3.578 3.576-1.623 1.619zm6.349-4.935l-4.935 4.935 4.935 4.933.209-.209-4.578-4.576h18.569v-.3H6.142l4.578-4.574z"}})])])])
          )
        }
      }
    